import { z } from "zod";
import { settingsStorageFactory } from "./settingsStorageFactory.ts";

const zEditImageWithPromptSettings = z.object({
  prompt: z.string().default(""),
  num_generations: z.number().default(4),
});

export const editImageWithPromptSettingsStorage = settingsStorageFactory(
  "edit-image-with-prompt-settings",
  3,
  zEditImageWithPromptSettings,
);
